import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../shared/alerts/alerts.service';
import { SharedService } from '../shared/shared.service';
import { BASIC, INST_INFO, MFA, USER } from '../shared/urls';
import { PublicKeyCredentialDescriptorJSON } from '../webauthn-json';
import {
  parseCreationOptionsFromJSON,
  create,
  parseRequestOptionsFromJSON,
  supported,
  AuthenticationPublicKeyCredential,
} from '../webauthn-json/browser-ponyfill';

import {
  RegistrationResponseExtendedJSON,
  RegistrationPublicKeyCredential,
} from '../webauthn-json/browser-ponyfill.extended';
import {
  createResponseToJSON,
  getResponseToJSON,
} from '../webauthn-json/extended';
declare var bootstrap: any;
@Component({
    selector: 'app-mfaoptions',
    templateUrl: './mfaoptions.component.html',
    styleUrls: ['./mfaoptions.component.scss'],
    standalone: false
})
export class MfaoptionsComponent implements OnInit {
  mfaResponce: any;
  ShowOtpScreen: boolean = false;
  otp: any;
  pushNotificationScreen: boolean = false;
  authenticatinFailed: boolean = false;
  pushType: any;
  x: number = 0;
  locationData: any;
  pushModel: any;
  processing: boolean = false;
  userDevices: any = [];
  selectedDeviceId: any;
  selectedDeviceName: any;
  emailSent: any;
  counter = 60;
  verify: boolean = false;
  editDeviceDetails: any;
  deviceName: any;
  editDeviceNameModel: any;
  noDevicesFoundErrMsg: boolean = false;
  pushModelTemplate: any;
  institutionInfo: any;
  mfaGroupOptions: any;
  defaultDevice: boolean = false;
  displayOptionType: any;
  isTimeExpired: boolean = false;
  isPushNotificationsEnabled: boolean = false;
  isFailedPushNotificationSent: boolean = false;
  ssoToken: any;
  yubiKeyRegistrationObject: any;
  yubiAuthType: any = 'yubicoOtpEnabled';
  yubicoAuthenticationResponse: any;
  fido2AuthenticationObject: any;
  locationDetails: any;
  locatedAdded: boolean = false;
  urlParams: any;
  isUnderMaintainance:boolean= false;
  isDeviceExists: any;
  isShowInstructionsToUpgrade: boolean=false;
  isNewDeviceRegistered: any;
  constructor(
    private sharedService: SharedService,
    private modalService: NgbModal,
    private router: Router,
    private alertService: AlertsService,
    private route: ActivatedRoute
  ) {
    // this.userData = JSON.parse(sessionStorage.getItem('userInfo'));
  }

  ngOnInit(): void {
    localStorage.clear();
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.reverseGeocode(
          position.coords.latitude,
          position.coords.longitude
        );
      },
      (error) => {
        return;
      },
      { enableHighAccuracy: true, maximumAge: 10000 }
    );
 
    if (sessionStorage.getItem('sso_token')) {
      this.ssoToken = sessionStorage.getItem('sso_token');
      this.getLocationDetils();
      this.checkLocationPermission();
      this.getUserDevices();
      this.getInstData();
      this.getMfaOptions();
    } else {
      this.router.navigate(['/login']);
    }
    this.route.queryParams.subscribe((params) => {
      if (params.trackingId) {
        this.urlParams = params;
      } else {
        this.urlParams = null;
      }
    });
  }
  checkLocationPermission() {
    this.isShowInstructionsToUpgrade=false;
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.reverseGeocode(
          position.coords.latitude,
          position.coords.longitude
        );
      },
      (error) => {
        return;
      },
      { enableHighAccuracy: true, maximumAge: 10000 }
    );
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      if (result.state === 'denied') {
        this.showLocationModal();
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log('Location accessed:', position);
            this.getUserDevices();
            
          },
          (error) => {
            console.error('Error getting location', error);
          }
        );
      }
      
    });
  }
  showLocationModal() {
    const modal = new bootstrap.Modal(document.getElementById('locationPermissionModal'));
    modal.show();
  }

  closeModal() {
    this.checkLocationPermission();
    const modalElement = document.getElementById('locationPermissionModal');
    const modalInstance = bootstrap.Modal.getInstance(modalElement);
    modalInstance.hide();

  }
  getMfaOptions() {
    let url = MFA.SUPERADMIN_MFA_SETUP + '?token=' + this.ssoToken;
    this.sharedService.commonGetHandler(url).subscribe(
      (data) => {
        let item = data.filter((a) => a.isPrimary == true);
        if (item.length != 0) {
          this.mfaGroupOptions = item[0];
        } else {
          this.mfaGroupOptions = {
            id: 5,
            groupName: 'Min-Enterprise-MFA-Options-Group',
            description: null,
            otpEnabled: true,
            pushYnEnabled: true,
            pushFrEnabled: true,
            pushFpEnabled: true,
            pushIrEnabled: true,
            tokenEnabled: true,
            smsEnabled: true,
            phoneCallEnabled: true,
            active: true,
            isEmailEnabled: true,
            isPrimary: true,
            phoneCallDetailsDTO: {
              standardMessage:
                'We have recieved multifactor authentication for your account . If you want to allow press 1. press 2 for decline',
              customizedMessage: null,
              customizedMessageWithPin: null,
              messageType: 'standard',
            },
            institutionId: 1,
          };
        }
      },
      (err) => {
        this.mfaGroupOptions = {
          id: 5,
          groupName: 'Min-Enterprise-MFA-Options-Group',
          description: null,
          otpEnabled: true,
          pushYnEnabled: true,
          pushFrEnabled: true,
          pushFpEnabled: true,
          pushIrEnabled: true,
          tokenEnabled: true,
          smsEnabled: true,
          phoneCallEnabled: true,
          active: true,
          isEmailEnabled: true,
          isPrimary: true,
          phoneCallDetailsDTO: {
            standardMessage:
              'We have recieved multifactor authentication for your account . If you want to allow press 1. press 2 for decline',
            customizedMessage: null,
            customizedMessageWithPin: null,
            messageType: 'standard',
          },
          institutionId: 1,
        };
      }
    );
  }
  getInstData() {
    let url = BASIC.API + 'organization/details' + '?token=' + this.ssoToken;
    this.sharedService.commonGetHandler(url).subscribe((data) => {
      this.institutionInfo = data;
      localStorage.setItem(
        'yubicoAuthenticationResponse',
        this.institutionInfo.yubicoKeyObject
      );
    });
  }

  validateOTP() {
    this.verify = true;
    let url = MFA.VALIDATE_OTP + '?token=' + this.ssoToken;
    let obj = {
      mfaOption: this.pushType,
      otp: this.otp,
      city: this.locationData.city,
      country: this.locationData.country,
      state: this.locationData.state,
      deviceId: this.selectedDeviceId,
      ipAddress: this.locationDetails,
      deviceTypes: 'Desktop',
      deviceOperatingSystem: null,
      deviceRestrictions: null,
    };
    this.sharedService.commonPostHandler(url, obj).subscribe((data) => {
      if (data.isValidOtp == true) {
        sessionStorage.setItem('currentJwtToken', JSON.stringify(data));
        //this.router.navigate(['employer/dashboard']);
        this.redirectToDashboard();
        this.pushModel.close();
        this.alertService.success(`Logedin successfully`);
      } else {
        this.otp = null;
        this.verify = false;
        if (this.pushType != 'yubi') {
          this.alertService.error(`Invalid Verification Code`);
        } else {
          this.alertService.error(
            `Unassigned YubiKey.Please get in touch with your administrator`
          );
        }
        if (this.counter == 0) {
          this.alertService.error(
            `Verification code got expired.Please try again later`
          );
          this.pushModel.close();
        }
      }
    });
  }
  sendPush(value, content) {
    this.isTimeExpired = false;
    this.isPushNotificationsEnabled = this.isFailedPushNotificationSent = false;
    // this.redirectToDashboard()
    this.otp = null;

    switch (value) {
      case 'email':
        this.displayOptionType = 'Email';
        break;
      case 'yubi':
        this.displayOptionType = 'Yubi';
        break;
      case 'face':
        this.displayOptionType = 'Face Recognition';
        break;
      case 'fingerPrint':
        this.displayOptionType = 'Finger Print';
        break;
      case 'phoneCall':
        this.displayOptionType = 'Phone Call';
        break;
      case 'otp':
        this.displayOptionType = 'Text Message';
        break;
      case 'minPin':
        this.displayOptionType = 'Min App Passcode';
        break;
      case 'minPrompt':
        this.displayOptionType = 'min Prompt';
        break;
    }
    this.pushModelTemplate = content;
    this.noDevicesFoundErrMsg = false;
    if (value == 'yubi' && this.mfaGroupOptions.yubicoFidoEnabled) {
      this.registerYubiKey();
    } else {
      if (
        this.userDevices.length == 0 &&
        value != 'otp' &&
        value != 'email' &&
        value != 'phoneCall'
      ) {
        this.noDevicesFoundErrMsg = true;
        setTimeout(() => {
          this.noDevicesFoundErrMsg = false;
        }, 5000);
      } else {
        this.processing = true;
        let ngbModalOptions: NgbModalOptions = {
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          centered: true,
        };
        this.pushModel = this.modalService.open(content, ngbModalOptions);
        if (value == 'minPin' || value == 'yubi') {
          this.ShowOtpScreen = true;
          this.pushNotificationScreen = false;
          this.pushType = value;
          this.processing = false;
        } else {
          let obj = {
            mfaOption: value,
            city: this.locationData.city || this.locationData.state,
            country: this.locationData.country,
            state: this.locationData.state,
            deviceId: this.selectedDeviceId,
            ipAddress: this.locationDetails,
          };
          var url = MFA.LOGIN_MFA + '?token=' + this.ssoToken;
          this.sharedService.commonPostHandler(url, obj).subscribe(
            (data) => {
              this.mfaResponce = data;
              this.processing = false;
              if (data.message == 'Push Notifications are not enabled') {
                this.pushNotificationScreen = true;
                this.isPushNotificationsEnabled = true;
              } else if (
                data.message == 'Failed to sent the push notification'
              ) {
                this.pushNotificationScreen = true;
                this.isFailedPushNotificationSent = true;
              } else if (
                data.message ==
                'Access Denied – Two Factor Authentication Failed.'
              ) {
                // this.alertService.error(res.message);
                this.pushNotificationScreen = true;
                this.authenticatinFailed = true;
                // this.pushModel.close();
              } else {
                if (value == 'otp' || value == 'email' || value == 'yubi') {
                  this.ShowOtpScreen = true;
                  this.pushNotificationScreen = false;
                  this.pushType = value;
                  if (this.pushType != 'yubi') {
                    this.timer();
                  }
                } else {
                  this.pushNotificationScreen = true;
                  this.ShowOtpScreen = false;
                  this.pushType = value;
                  this.x = 0;
                  this.pushToMobile();
                }
              }
            },
            (err) => {
              this.processing = false;
              this.pushModel.close();
            }
          );
          //
          //  })
        }
      }
    }
  }
  pushToMobile() {
    let MFA_PUSH_URL =
      MFA.LOGIN_PUSH_MFA +
      '?' +
      'trackingId=' +
      this.mfaResponce.trackingId +
      '&requestId=null&' +
      'token=' +
      this.ssoToken;
    // let obj = {
    //   city: this.locationData.city,
    //   country: this.locationData.country,
    //   state: this.locationData.state,
    //   ipAddress: this.locationData.ipAddress,
    //   zipCode: this.locationData.postcode,
    // }
    // console.log('obj data',obj)
    console.log('mfa push location', this.locationData);
    this.sharedService
      .commonPostHandler(MFA_PUSH_URL, this.locationData)
      .subscribe(
        (res) => {
          if (res.isAuthenticated == true) {
            sessionStorage.setItem('currentJwtToken', JSON.stringify(res));
            this.redirectToDashboard();
            this.pushModel.close();
          } else {
            if (
              res.message &&
              res.message == 'Access Denied – Two Factor Authentication Failed.'
            ) {
              this.alertService.error(res.message);
              this.pushNotificationScreen = false;
              // this.authenticatinFailed =true;
              this.pushModel.close();
            } else {
              if (this.x != 100) {
                this.x++;
                if (this.x < 13) {
                  setTimeout(() => {
                    this.pushToMobile();
                  }, 5000);
                } else {
                  this.isTimeExpired = true;
                  this.x = 0;
                }
              }
            }
          }
        },
        (err) => {
          this.alertService.error(`Authentiaction Failed`);
        }
      );
  }
  close() {
    this.x = 100;
    this.pushModel.close();
    this.processing = false;
  }
  addDevice(addDevice) {
    this.emailSent = null;
    if (this.userDevices.length == 0) {
      this.enrollNew();
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true,
    };
    this.modalService.open(addDevice, ngbModalOptions);
  }
  getUserDevices() {
    const url = USER.GET_USER_DEVICE + '?token=' + this.ssoToken;
    this.sharedService.commonGetHandler(url).subscribe((data) => {
      this.isDeviceExists=data.isDeviceExists
      this.isNewDeviceRegistered=data.newDeviceRegistered
      this.isShowInstructionsToUpgrade =false;
      if(!this.isShowInstructionsToUpgrade && !this.isNewDeviceRegistered){
        this.isShowInstructionsToUpgrade = true;
      } else{
        this.isShowInstructionsToUpgrade =false;
      }
      if (data?.deviceDetails?.length) {
        this.userDevices = data.deviceDetails;
        // this.userDevices = data.deviceDetails.filter((device: any) => device.isLatest === true);
      } else {
        this.userDevices = [];
      }
      this.isUnderMaintainance=false
      if (this.userDevices.length != 0) {
        let selectedDeviceDetails = this.userDevices.filter(
          (a) => a.defaultDevice == true
        );
        if (selectedDeviceDetails.length != 0) {
          this.selectedDeviceId = selectedDeviceDetails[0].deviceId;
          this.selectedDeviceName = selectedDeviceDetails[0].deviceName;
        } else {
          this.selectedDeviceId = this.userDevices[0].deviceId;
          this.selectedDeviceName = this.userDevices[0].deviceName;
          this.defaultDevice = true;
        }
      }
    },(err) => {
    
      if (err.status === 400) {
        // Bad Request
        console.error('Bad Request: Invalid request data.', err.error);
      } else if (err.status === 401) {
        // Unauthorized
        console.error('Unauthorized: Invalid credentials or token.', err.error);
        // Optionally, redirect to login or refresh token
      } else if (err.status === 404) {
        // Not Found
        console.error('Not Found: The requested resource could not be found.', err.error);
      } else if (err.status === 500) {
        // Internal Server Error
        console.error('Internal Server Error: Something went wrong on the server.', err.error);
      }
      else if (err.status === 503) {
       this.isUnderMaintainance=true;
      }
      else if (err.status === 504) {
        setTimeout(() => {
          this.getUserDevices();
        }, 2000);
      } else {
        // Other errors
        console.error('An unknown error occurred:', err);
      }

      this.processing = false;
    });
  }
  chnageDeviceDetails() {
    let selectedDeviceDetails = this.userDevices.filter(
      (a) => a.deviceId == this.selectedDeviceId
    );
    this.selectedDeviceName = selectedDeviceDetails[0].deviceName;
  }
  deleteUserDevice(id) {
    const url = USER.DELETE_DEVICE + '/' + id + '?token=' + this.ssoToken;
    this.sharedService.commonDeleteHandler(url).subscribe((data) => {
      this.getUserDevices();
    });
  }
  timer() {
    this.verify = false;
    this.counter = 120;
    let intervel = setInterval(() => {
      this.counter = this.counter - 1;
      if (this.counter == 0) {
        clearInterval(intervel);
        if (this.verify == false) {
          this.alertService.error(
            `Verification code got expired.Please try again later`
          );
          this.pushModel.close();
        }
      }
    }, 1000);
  }
  enrollNew() {
    // const ipUrl =
    //   'https://api.ipapi.com/check?access_key=3f6f89e6f1cc29a4cf281e9ee785fce6&format=1';
    // this.sharedService.commonGetHandler(ipUrl).subscribe((location) => {

    const url = USER.SEND_INVITATION + '?token=' + this.ssoToken;
    this.sharedService
      .commonPostHandler(url, this.locationData)
      .subscribe((data) => {
        this.emailSent = data.message;
        this.alertService.success(`Email sent to your mail.`);
      });
    // });
  }
  enterKey(event) {
    if (event.keyCode === 13) {
      this.validateOTP();
    }
  }
  editDeviceName(editDevice, id) {
    this.defaultDevice = false;
    let editDeviceDetails = this.userDevices.filter((a) => a.deviceId == id);
    this.editDeviceDetails = editDeviceDetails[0];
    this.deviceName = editDeviceDetails[0].deviceName;
    this.defaultDevice = this.editDeviceDetails.defaultDevice;

    let ngbModalOptions: NgbModalOptions = {
      // backdrop: 'static',
      // keyboard: false,
      size: 'sm',
      centered: true,
    };
    this.editDeviceNameModel = this.modalService.open(
      editDevice,
      ngbModalOptions
    );
  }
  updateDeviceName(item) {
    if (item) {
      this.deviceName = item.deviceName;
      var deviceId = item.deviceId;
      this.defaultDevice = true;
    } else {
      var deviceId = this.editDeviceDetails.deviceId;
    }
    let url =
      BASIC.API +
      'device/display/name?name=' +
      this.deviceName +
      '&deviceId=' +
      deviceId +
      '&defaultDevice=' +
      this.defaultDevice +
      '&token=' +
      this.ssoToken;
    this.sharedService.commonPutHandler(url, null).subscribe((data) => {
      this.getUserDevices();
      if (item) {
        this.alertService.success(`Default device updated successfully`);
      } else {
        this.alertService.success(`Device Name updated successfully`);
      }
      this.editDeviceNameModel.close();
    });
  }
  redirectToDashboard() {
    let url = INST_INFO.USER_DATA;
    this.sharedService.commonGetHandler(url).subscribe(
      (userData) => {
        sessionStorage.setItem('userInfo', JSON.stringify(userData));
        if (userData.userType == 'InstitutionUser') {
          if (this.urlParams) {
            this.router.navigate(['/enterprise/access-requests'], {
              queryParams: {
                trackingId: this.urlParams.trackingId,
                requestId: this.urlParams.requestId,
              },
            });
          } else {
            this.router.navigate(['/enterprise/dashboard']);
          }
        } else if (userData.userType == 'superadmin') {
          this.router.navigate(['superadmin/dashboard']);
        } else if (userData.userType == 'support') {
          this.router.navigate(['support/dashboard']);
        }
        this.alertService.success(`You have successfully logged in!`);
      },
      (err) => {
        this.processing = false;
      }
    );
  }
  getLocationDetils() {
    
    const ipUrl =
     // 'https://api.ipstack.com/check?access_key=c71570015cd09f24e40f62fbe742963c&format=1';
       'https://api.ipify.org'
    //  this.sharedService.commonGetHandler(ipUrl).subscribe(ipaddress => {
    this.sharedService.commonGetHandler(ipUrl).subscribe((location) => {
      this.locationDetails = location;
    });

    // let locationDetailsDTO = {
    //   city: this.locationData.city,
    //   country: this.locationData.country,
    //   state: this.locationData.state,
    //   ipAddress: this.locationDetails.ip,
    //   zipCode: this.locationData.postcode,
    // };
    // console.log("enroll data:",locationDetailsDTO)
  }
  resendPush() {
    this.close();
    this.sendPush(this.pushType, this.pushModelTemplate);
  }
  logout() {
    this.router.navigate(['/login']);
    // sessionStorage.clear();
    localStorage.clear();
  }
  registeredCredentials(): PublicKeyCredentialDescriptorJSON[] {
    return this.getRegistrations().map((reg) => ({
      id: reg.rawId,
      type: reg.type,
    }));
  }

  async register(data): Promise<void> {
    const cco = parseCreationOptionsFromJSON({
      publicKey: {
        challenge: data.challenge,
        rp: { name: data.rp.name },
        user: {
          id: data.user.id,
          name: data.user.name,
          displayName: data.user.displayName,
        },
        pubKeyCredParams: data.pubKeyCredParams,
        excludeCredentials: this.registeredCredentials(),
        authenticatorSelection: data.authenticatorSelection,
        extensions: {
          credProps: true,
        },
      },
    });
    this.saveRegistration(await create(cco));
    this.authenticate();
  }

  async authenticate(): Promise<void> {
    let yubicoAuthenticationResponse = JSON.parse(
      localStorage.getItem('yubicoAuthenticationResponse')
    );
    const cro = parseRequestOptionsFromJSON({
      publicKey: {
        challenge: yubicoAuthenticationResponse.publicKey.challenge,
        allowCredentials: this.registeredCredentials(),
        userVerification: 'discouraged',
        extensions: yubicoAuthenticationResponse.publicKey.extensions,
        rpId: yubicoAuthenticationResponse.publicKey.rpId,
      },
    });
    await this.get(cro);
  }

  async testSupported() {
    document.querySelector('#supported .status')!.textContent = '…';
    document.querySelector('#supported .status')!.textContent = supported()
      ? ' ✅'
      : ' ❌';
  }

  registerYubiKey() {
    let url =
      BASIC.API +
      'register/start?username=' +
      this.institutionInfo.username +
      '&token=' +
      this.ssoToken;
    this.sharedService.commonPostHandler(url, null).subscribe(async (data) => {
      if (this.institutionInfo.isYubicoKeyRegistered == true) {
        localStorage.webauthnExampleRegistrations = JSON.stringify(
          [data],
          null,
          '  '
        );
        let yubicoAuthenticationResponse = JSON.parse(
          this.institutionInfo.yubicoKeyObject
        );
        const cro = parseRequestOptionsFromJSON({
          publicKey: {
            challenge: yubicoAuthenticationResponse.publicKey.challenge,
            allowCredentials:
              yubicoAuthenticationResponse.publicKey.allowCredentials,
            userVerification: 'discouraged',
            extensions: yubicoAuthenticationResponse.publicKey.extensions,
            rpId: yubicoAuthenticationResponse.publicKey.rpId,
          },
        });
        await this.get(cro);
        localStorage.setItem(
          'yubicoAuthenticationResponse',
          this.institutionInfo.yubicoKeyObject
        );

        //  this.authenticate();
      } else {
        this.yubiKeyRegistrationObject = data;
        this.register(data);
      }
    });
  }
  getRegistrations(): RegistrationResponseExtendedJSON[] {
    const registrations = JSON.parse(
      localStorage.webauthnExampleRegistrations || '[]'
    );
    return registrations;
  }

  setRegistrations(
    registrations: RegistrationResponseExtendedJSON[],
    display: boolean = true
  ): void {
    this.completeRegistartion(registrations);
    localStorage.webauthnExampleRegistrations = JSON.stringify(
      registrations,
      null,
      '  '
    );
    this.displayRegistrations();
  }

  saveRegistration(registration: RegistrationPublicKeyCredential): void {
    const registrations = this.getRegistrations();
    registrations.push(registration.toJSON());
    this.setRegistrations(registrations);
  }

  registrationElem(): HTMLTextAreaElement {
    return document.querySelector('#registrations')! as HTMLTextAreaElement;
  }

  displayRegistrations() {
    this.registrationElem().value = JSON.stringify(
      this.getRegistrations(),
      null,
      '  '
    );
  }

  withStatus(selector: string, fn: () => Promise<void>) {
    return async function () {
      document.querySelector('#error')!.textContent = '';
      document.querySelector(selector)!.textContent = '…';
      try {
        await fn();
        document.querySelector(selector)!.textContent = ' ✅';
      } catch (e) {
        document.querySelector(selector)!.textContent = ' ❌';
        console.error(e);
        document.querySelector('#error')!.textContent = e;
      }
    };
  }

  async saveInput(): Promise<void> {
    document.querySelector('#error')!.textContent = '';
    this.registrationElem().style.backgroundColor = 'rgba(255, 127, 0, 0.5)';
    try {
      this.setRegistrations(JSON.parse(this.registrationElem().value), false);
      this.registrationElem().style.backgroundColor = 'rgba(0, 255, 0, 0.5)';
    } catch (e) {
      this.registrationElem().style.backgroundColor = 'rgba(255, 0, 0, 0.5)';
      console.error(e);
      document.querySelector('#error')!.textContent = e;
    }
  }

  completeRegistartion(data) {
    let url = BASIC.API + 'register/finish?token=' + this.ssoToken;
    let obj = {
      publicKeyCredentialsJson: data,
      publicKeyCredentialsOptions: {
        rp: this.yubiKeyRegistrationObject.rp,
        user: this.yubiKeyRegistrationObject.user,
        challenge: this.yubiKeyRegistrationObject.challenge,
        pubKeyCredParams: this.yubiKeyRegistrationObject.pubKeyCredParams,
        timeout: null,
        excludeCredentials: this.yubiKeyRegistrationObject.excludeCredentials,
        authenticatorSelection:
          this.yubiKeyRegistrationObject.authenticatorSelection,
        attestation: this.yubiKeyRegistrationObject.attestation,
        extensions: this.yubiKeyRegistrationObject.extensions,
      },
    };
    this.sharedService.commonPostHandler(url, obj).subscribe((data) => {
      this.yubicoAuthenticationResponse = data;
      localStorage.setItem(
        'yubicoAuthenticationResponse',
        JSON.stringify(this.yubicoAuthenticationResponse)
      );
      this.authenticate();
    });
  }
  authenticateFido() {
    let url = BASIC.API + 'authentication/finish?token=' + this.ssoToken;
    let obj = {
      publicKeyCredentialJson: this.fido2AuthenticationObject,
      publicKey: JSON.parse(
        localStorage.getItem('yubicoAuthenticationResponse')
      ),
      username: this.institutionInfo.username,
      city: this.locationData.city,
      country: this.locationData.country,
      state: this.locationData.state,
      ipAddress: this.locationDetails,
    };

    this.sharedService.commonPostHandler(url, obj).subscribe((data) => {
      if (data.isAuthenticated == true) {
        sessionStorage.setItem('currentJwtToken', JSON.stringify(data));
        this.redirectToDashboard();
      }
    });
  }

  async create(
    options: CredentialCreationOptions
  ): Promise<RegistrationPublicKeyCredential> {
    const response = (await navigator.credentials.create(
      options
    )) as RegistrationPublicKeyCredential;
    response.toJSON = () => createResponseToJSON(response);
    return response;
  }

  async get(
    options: CredentialRequestOptions
  ): Promise<AuthenticationPublicKeyCredential> {
    const response = (await navigator.credentials.get(
      options
    )) as AuthenticationPublicKeyCredential;
    response.toJSON = () => getResponseToJSON(response);
    console.log(JSON.stringify(response));
    localStorage.setItem('yubiAFterlogin', JSON.stringify(response));
    this.fido2AuthenticationObject = response;
    this.authenticateFido();
    return response;
  }
  reverseGeocode(latitude, longitude) {
    const link = `https://nominatim.openstreetmap.org/reverse?format=json&lat=17.494793&lon=78.399643&zoom=18&addressdetails=1`;
    // //  const link =
    // //  'https://maps.googleapis.com/maps/api/geocode/json?latlng=' +
    // 17.494793,78.399643+
    //   '&key=AIzaSyAtqpQzxg1Jbz3QBYDo58aTgOz22vxc8jw';
    this.sharedService.commonGetHandler(link).subscribe((data) => {
      this.locatedAdded = true;
      let locationDetailsDTO = {
        city: data.address.city,
        country: data.address.country,
        state: data.address.state,
        ipAddress: this.locationDetails,
        zipCode: data.address.postcode,
      };
      this.locationData = locationDetailsDTO;
    });
    // try {
    //   const response = await fetch(link);
    //   const data = await response.json();
    //   let locationDetailsDTO = {
    //     city: data.address.city,
    //     country: data.address.country,
    //     state: data.address.state,
    //     ipAddress: this.locationDetails.ip || null,
    //     zipCode: data.address.postcode,
    //   };
    //   this.locationData=locationDetailsDTO
    //   console.log('assign location details',this.locationData)
    //   this.locatedAdded=true;
    //     return data;
    // } catch (err) {
    //   console.error("Error fetching reverse geocoding data:", err);
    // }
  }
  closeInstructions(type:any){


      if(type == 'skip'){
        this.isShowInstructionsToUpgrade=false;
      }
      else{
        this.getUserDevices()
        this.isShowInstructionsToUpgrade=false;
      }
  }


}
